import { toast } from "@/v2-ui/toast"
import Button from "@/v2-backoffice-client/components/button"
import { useClaimCollectionOwnerMutation } from "@/v2-backoffice-client/license/collections/license.collectionOwner.claim.mutation"
import { evictInvoiceCollectionQueries } from "@/v2-backoffice-client/license/license.utils"

export type LicenseCollectionClaimButtonProps = {
  customerId: number
  debtorName: string
}

// "This one is mine" for an unassigned collections row (C6: unowned overdue
// stays visible and claimable, never hidden). Assigns the acting operator
// server-side — the client doesn't know its own user id — and every row of
// the customer picks the owner up on the refetch.
function LicenseCollectionClaimButton(
  props: LicenseCollectionClaimButtonProps,
) {
  const { customerId, debtorName } = props

  const [claimOwner, { loading }] = useClaimCollectionOwnerMutation({
    update: evictInvoiceCollectionQueries,
    onCompleted() {
      toast({
        variant: "success",
        title: "Claimed",
        description: `You now own the collections dialogue with ${debtorName}.`,
      })
    },
    onError(error) {
      toast({
        variant: "destructive",
        title: "Failed to claim",
        description: error.message,
      })
    },
  })

  return (
    <Button
      type="button"
      size="sm"
      variant="outline"
      isLoading={loading}
      data-feature-code="UI_BackofficeCollections_Owner_Claim"
      onClick={(e) => {
        // The row link would otherwise swallow the click.
        e.stopPropagation()
        void claimOwner({ variables: { customerId } })
      }}
    >
      Claim
    </Button>
  )
}

export default LicenseCollectionClaimButton
